import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import {
  BpkList,
  BpkListItem,
} from '@skyscanner-internal/backpack-web/bpk-component-list';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import withErrorBoundary from '../ErrorBoundary';

import type { SitemapLinksBlockProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './SitemapLinksBlock.module.scss';

const Title = ({ title }: { title: string | undefined }) =>
  title ? (
    <BpkText
      textStyle={TEXT_STYLES.subheading}
      tagName="h3"
      className={STYLES.title}
    >
      {title}
    </BpkText>
  ) : null;

const LinksSection = ({
  links,
}: {
  links: Array<{ url: string; linkString: string }>;
}) => (
  <BpkList className={STYLES.linksSection}>
    {links.map((link) => (
      <BpkListItem key={link.linkString} className={STYLES.linksListItem}>
        <BpkLink implicit href={link.url}>
          {link.linkString}
        </BpkLink>
      </BpkListItem>
    ))}
  </BpkList>
);

const NoLinksMessage = ({
  noLinksMessage,
}: {
  noLinksMessage: string | undefined;
}) =>
  noLinksMessage ? (
    <div className={STYLES.noLinksMessage}>
      <BpkText>{noLinksMessage}</BpkText>
    </div>
  ) : null;

const SitemapLinksBlock = ({ sections }: SitemapLinksBlockProps) => (
  <div className={STYLES.SitemapLinksBlock}>
    {sections.map((section) => (
      <div key={`sitemap-links-block-section-${section.id}`}>
        <Title title={section.title} />
        {section.links.length > 0 ? (
          <LinksSection links={section.links} />
        ) : (
          <NoLinksMessage noLinksMessage={section.noLinksMessage} />
        )}
      </div>
    ))}
  </div>
);

const SitemapLinksBlockWithErrorBoundary = withErrorBoundary(
  SitemapLinksBlock,
  'sitemap-links-block-component',
);
export default SitemapLinksBlockWithErrorBoundary;
